import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user-data",
  "use": "user-data-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"user-data\"><path d=\"M24.85 3.85A14.89 14.89 0 0017 1v2a12.68 12.68 0 016.56 2.4zm1.53 1.31l-1.29 1.53a13 13 0 013.43 12.78l1.88.7a15 15 0 00-4-15zm-.67 19.46a10 10 0 00-6-6.92 6 6 0 10-7.4 0 10.09 10.09 0 00-6 6.91A13 13 0 0115 3V1a15 15 0 1014.72 21.05l-1.88-.69a13.09 13.09 0 01-2.13 3.26zM12 13a4 4 0 114 4 4 4 0 01-4-4zM8 26.25a8 8 0 0115.92 0 12.91 12.91 0 01-15.92 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/user-data.svg
// module id = XzLX
// module chunks = 38 43